var common = require("../../utiles/common.js")

module.exports = {
    register: function () {
        document.createElement('reset-password')
        ko.components.register('reset-password', {
            viewModel: function (params) {
                var $this = this;
                var urlParam = common.urlSearch(window.location.href);
                // 如果是密码不符合当前密码策略的情况
                var badPassword = $("body").data("badPassword");
                var type = $("body").data("type")?$("body").data("type").type:"LOGIN";
                console.log(type)
                var login_style = "";
                var param = window.location.href.split('?')[1] ? window.location.href.split('?')[1] : ""
                if(localStorage.getItem("loginTemplate") === 'smallConcise'){
                    login_style = "?login_style=IOA&" + param;
                }
                $this.loginUrl = '#/login' + login_style;
                $("body").removeData("badPassword");
                $this.phoneToken = urlParam.token;
                $this.errorMessage = ko.observable("");
                $this.verifyId = ko.observable("");
                $this.token = ko.observable("");
                $this.codeMsg = ko.observable("发生验证码");
                $this.step = ko.observable("");
                $this.qualifyName = ko.observable("");
                $this.tel = ko.observable("");
                console.log(badPassword)
                var cryptKey;
                if(sessionStorage.getItem("cryptKey")){
                    cryptKey = sessionStorage.getItem("cryptKey");
                }else{
                    cryptKey = "04" + common.fetch("/auth/flow/login/getSm2PubK").data;
                }
                if(sessionStorage.getItem("badReason")){
                    common.errorAlert(sessionStorage.getItem("badReason"));
                    sessionStorage.removeItem("badReason");
                }
                if (badPassword) {
                    $this.token(badPassword.token);
                    $this.errorMessage(badPassword.reason);
                    $this.step("badPassword");
                } else {
                    $this.step(params.step);
                }
                if(params.step == "update"){
                    common.fetch("/auth/credential/listCredential", {
                        type: "GET",  query: {},
                        handleError: function (data) {
                            $this.errorMessage(data.message);
                        },
                        success: function (result) {
                            $this.policyList = result.data;
                            console.log($this.policyList)
                            $this.qualifyName(result.data[0].qualifyName);
                        }
                    })
                }

                // $this.step("mail");
                $this.goStep = function (newStep) {
                    $this.step("blank");
                    $this.formItems = [];
                    $this.step(newStep);
                    if(newStep == "updateOptions"){
                        $this.verify();
                        type = "FORGET";
                    }
                }
               
                //判断是否绑定手机号
                $this.verify = function(){
                    var res = common.fetch("/auth/personSubject/loginPerson").data;
                    if(res && res.individualData && res.individualData.phone){
                        var reg = /1(\d{2})\d{4}(\d{4})/g;
                        $this.tel(res.individualData.phone.replace(reg,"1$1****$2"));
                    }else{
                        common.errorAlert("未绑定手机号,请先绑定手机号");
                    }
                }

                //发送短信
                $this.noteSM = function(){
                    console.log($this.formItems)
                    var validationResult = common.validateAll($this.formItems);
                    if (validationResult.valid) {
                        if($this.step() == "options"){
                            var params = $('.content.options input').serializeObject();
                        }else{
                            var params = $('.content.updateOptions input').serializeObject();
                        }
                        delete params.verifyCode;
                        console.log(params)
                        common.fetch("/auth/credential/validateVerifyCode", {
                            type: "POST", data: JSON.stringify(params),
                            handleError: function (data) {
                                $("img.verifyImg").attr("src", "/auth/verification/img?type=FORGET_PWD&random=" + Math.random());
                                common.errorAlert(data.message);
                            },
                            success: function (result) {
                                $this.errorMessage("");
                                
                                $this.verifyId = result.data.verifyId;
                                if($this.step() == "options"){
                                    $this.step("badPassword");
                                }else{
                                    $this.step("updateBadPassword");
                                }
                            }
                        })
                    } else {
                        //$this.errorMessage(validationResult.msg)
                    }
                }
                // 发送新的密码
                $this.badPassword = function () {
                    var validationResult = common.validateAll($this.formItems);
                    if (validationResult.valid) {
                        if($this.step() == "updateBadPassword"){
                            var params = $('.content.updateBadPassword input').serializeObject();
                        }else{
                            var params = $('.content.badPassword input').serializeObject();
                        }
                        delete params.repeatPassword;
                        if($this.token()){
                            params.token = $this.token();
                        }else{
                            params.token = $this.verifyId
                        }
                        params.password = common.sm2.doCrypt(cryptKey,params.password);
                        params.type = type;
                        console.log(params)
                        common.fetch("/auth/credential/resetPassword", {
                            type: "POST", data: JSON.stringify(params),
                            handleError: function (data) {
                                $("img.verifyImg").attr("src", "/auth/verification/img?type=FORGET_PWD&random=" + Math.random());
                                $this.errorMessage(data.message);
                            },
                            success: function (result) {
                                console.info("result",result)
                                $this.errorMessage("");
                                if($this.step() == "updateBadPassword"){
                                    $this.step("updateFinished");
                                }else{
                                    $this.step("finished");
                                }
                                if(result&&result.data&&result.data.type == "LOGIN"){
                                    common.redirectTo(result.data.redirectUrl)
                                }
                            }
                        })
                    } else {
                       // $this.errorMessage(validationResult.msg)
                    }
                }
                //修改密码
                $this.update = function(){
                    var validationResult = common.validateAll($this.formItems);
                    if (validationResult.valid) {
                        //common.base64.encode
                        var params = $('.content.update input').serializeObject();
                        params.newPwd = common.sm2.doCrypt(cryptKey,params.newPwd);
                        params.originalPwd = common.sm2.doCrypt(cryptKey,params.originalPwd);
                        params.dataTypeQualifyName = $this.qualifyName();
                        if(common.getStorage()){
                            params.individualId = common.getStorage().user.individualId
                        }
                        delete params.newPwdConfirm;
                        common.fetch("/auth/credential/changePassword", {
                            type: "POST", data: JSON.stringify(params),
                            handleError: function (data) {
                                $this.errorMessage(data.message);
                            },
                            success: function (result) {
                                $this.errorMessage("");
                                $this.step("updateFinished");
                            }
                        })
                    } else {
                       // $this.errorMessage(validationResult.msg)
                    }
                }

                $this.goApps = function () {
                    common.redirectTo("/#/appList")
                }

                //设置手机号
                $this.setPhone = function(){
                    var query = $('.content.set_phone input').serializeObject();
                    console.log(query)
                   
                    common.fetch("/auth/credential/resetPhone", {
                        type: "POST", data: JSON.stringify({
                            phone:query.phone,
                            token:urlParam.token,
                            smsCode:query.smsCode
                        }),
                        handleError: function (data) {
                            $this.errorMessage(data.message);
                        },
                        success: function (result) {
                            $this.errorMessage("");
                            $this.step("updateFinished");
                        }
                    })
                }
            },
            template: require("./template/ResetPassword.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/component/resetPassword/RestPassword.js
// module id = 130
// module chunks = 0